import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.shared.patient': {
         guardianPesel: 'PESEL opiekuna: {{guardianPesel}}',
         identifierType: {
            BirthDate: 'Data urodzenia',
            GuardianPesel: 'PESEL opiekuna',
            MedicalRecordNumber: 'Nr kart.',
            NationalIdentificationNumber: 'PIN UE',
            Passport: 'Paszport',
            Pesel: 'PESEL',
         },
         medicalRecordNumber: 'Nr kart.: {{medicalRecordNumber}}',
         passport: 'Paszport: {{passport}}',
         pesel: 'PESEL: {{peselVal}}',
         pinue: 'PIN UE: {{nationalIdentificationNumber}}',
      },
   },
};

export const translationKeys = createScopedTranslationKeys(translations.pl, '~libs.shared.patient');
